import COS from "cos-js-sdk-v5";
// import { post, get } from '@/utils/request'
const sign = {};
import axios from "axios";
import {
  saveFile,
  deleteFile,
  getUploadSignature,
} from "@saas/server-api/src/material/index.js";
import {
  createTranscode,
  getDesTranscode,
} from "@saas/server-api/src/live-sdk/index.js";
export const cos = new COS({
  getAuthorization: function (options, callback) {
    console.log("getAuthorization", options);

    callback({ ...sign });
  },
});
// 获取带签名的url
export const getObjectUrl = (data) => {
  const cos = new COS({
    SecretId: data.sign.Credentials.TmpSecretId, // sts服务下发的临时 secretId
    SecretKey: data.sign.Credentials.TmpSecretKey, // sts服务下发的临时 secretKey
    SecurityToken: data.sign.Credentials.Token, // sts服务下发的临时 SessionToken
  });
  const url = cos.getObjectUrl({
    Bucket: data.bucket /* 填入您自己的存储桶，必须字段 */,
    Region: data.region /* 存储桶所在地域，例如 ap-beijing，必须字段 */,
    Key: data.key /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），支持中文，必须字段 */,
  });
  return url;
};

export const cosUploadFile = (uploadData, data, callbackConfig) => {
  let cos = null;
  cos = new COS({
    getAuthorization: function (options, callback) {
      console.log("getAuthorization", options);
      callback({
        TmpSecretId: data.sign.Credentials.TmpSecretId,
        TmpSecretKey: data.sign.Credentials.TmpSecretKey,
        SecurityToken: data.sign.Credentials.Token,
        // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
        StartTime: data.sign.StartTime, // 时间戳，单位秒，如：1580000000
        ExpiredTime: data.sign.ExpiredTime, // 时间戳，单位秒，如：1580000000
        ScopeLimit: true, // 细粒度控制权限需要设为 true，会限制密钥只在相同请求
      });
      // callback({ ...sign })
    },
  });
  cos.uploadFile(
    {
      Bucket: data.bucket /* 填入您自己的存储桶，必须字段 */,
      Region: data.region /* 存储桶所在地域，例如ap-beijing，必须字段 */,
      Key: data.key /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */,
      Body: uploadData.file /* 必须，上传文件对象，可以是input[type="file"]标签选择本地文件后得到的file对象 */,
      SliceSize:
        1024 * 1024 * 1 /* 触发分块上传的阈值，超过5MB使用分块上传，非必须 */,
      onTaskReady: callbackConfig.onTaskReady,
      onProgress: callbackConfig.onProgress,
      onFileFinish: callbackConfig.onFileFinish,
    },
    function (err, data) {
      console.log(err || data);
      if (err) {
        callbackConfig.onError?.(err);
      } else {
        callbackConfig.onSuccess?.(data);
      }
    }
  );
  return cos;
};
export const downloadFile = (data, filename) => {
  let cos = null;
  cos = new COS({
    getAuthorization: function (options, callback) {
      callback({
        TmpSecretId: data.sign.Credentials.TmpSecretId,
        TmpSecretKey: data.sign.Credentials.TmpSecretKey,
        SecurityToken: data.sign.Credentials.Token,
        // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
        StartTime: data.sign.StartTime, // 时间戳，单位秒，如：1580000000
        ExpiredTime: data.sign.ExpiredTime, // 时间戳，单位秒，如：1580000000
        ScopeLimit: true, // 细粒度控制权限需要设为 true，会限制密钥只在相同请求
      });
      // callback({ ...sign })
    },
  });
  cos.getObjectUrl(
    {
      Bucket: data.bucket /* 填入您自己的存储桶，必须字段 */,
      Region: data.region /* 存储桶所在地域，例如ap-beijing，必须字段 */,
      Key: data.key /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */,
    },
    function (err, res) {
      if (err) return console.log(err);
      console.log(res);
      /* 通过指定 response-content-disposition=attachment 实现强制下载 */
      // res.Url +
      // (res.Url.indexOf("?") > -1 ? "&" : "?") +
      // "response-content-disposition=attachment";
      /* 可拼接 filename 来实现下载时重命名 */
      /* downloadUrl += ';filename=myname'; */
      // （推荐使用 window.open()方式）这里是新窗口打开 url，如果需要在当前窗口打开，可以使用隐藏的 iframe 下载，或使用 a 标签 download 属性协助下载
      var downloadUrl = res.Url;
      if (window.isElectron) {
        // downloadUrl = downloadUrl + (downloadUrl.indexOf("?") > -1 ? "&" : "?") + "response-content-disposition=attachment";
        const { file_path, file_id, openType = "", type } = data;
        window.openOrDownloadFile({
          fileUrl: downloadUrl,
          file_id,
          file_path,
          openType,
          type,
        });
      } else {
        if (filename) {
          filename = encodeURIComponent(filename);
          downloadUrl = `${
            downloadUrl + (downloadUrl.indexOf("?") > -1 ? "&" : "?")
          }response-content-disposition=attachment;filename=${filename}`;
        }
        window.open(downloadUrl);
      }
    }
  );
};

export const getOssUrl = (data) => {
  let cos = null;
  cos = new COS({
    getAuthorization: function (options, callback) {
      callback({
        TmpSecretId: data.sign.Credentials.TmpSecretId,
        TmpSecretKey: data.sign.Credentials.TmpSecretKey,
        SecurityToken: data.sign.Credentials.Token,
        // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
        StartTime: data.sign.StartTime, // 时间戳，单位秒，如：1580000000
        ExpiredTime: data.sign.ExpiredTime, // 时间戳，单位秒，如：1580000000
        ScopeLimit: true, // 细粒度控制权限需要设为 true，会限制密钥只在相同请求
      });
      // callback({ ...sign })
    },
  });
  return cos.getObjectUrl({
    Bucket: data.bucket /* 填入您自己的存储桶，必须字段 */,
    Region: data.region /* 存储桶所在地域，例如ap-beijing，必须字段 */,
    Key: data.key /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */,
  });
};

// 参数：file, params, callbackConfig
// 返回值 cos
export const uploadFilToCdn = async (
  file,
  params = {},
  callbackConfig = {}
) => {
  let cos = null;
  // 素材库父级id
  // const pId = params.pId || 0
  // 素材类型
  const materialType = params.type;
  let taskId = null;
  let cancelSource = null;
  if (!materialType) {
    if (callbackConfig.onError) {
      callbackConfig.onError("素材类型参数为必传");
    }
    return;
  }
  // 上传任务准备
  callbackConfig.onTaskReady = callbackConfig.onTaskReady || (() => {});
  // cos实例
  callbackConfig.onCosReady = callbackConfig.onCosReady || (() => {});
  // 上传进度
  callbackConfig.onProgress = callbackConfig.onProgress || (() => {});
  // 文件上传完成
  callbackConfig.onFileFinish = callbackConfig.onFileFinish || (() => {});
  // 上传失败或者同步失败
  callbackConfig.onError = callbackConfig.onError || (() => {});
  // 上传成功
  callbackConfig.onSuccess = callbackConfig.onSuccess || (() => {});
  // 同步完成
  callbackConfig.onSyncComplete = callbackConfig.onSyncComplete || (() => {});
  try {
    const signRes = await getUploadMaterialSign({
      name: file.name,
      type: materialType,
    });
    if (signRes.code === 1) {
      cos = cosUploadFile({ file }, signRes.data, {
        onTaskReady: (id) => {
          console.log("onTaskReady", id);

          taskId = id;
          callbackConfig.onTaskReady(id);
        },
        onProgress: callbackConfig.onProgress,
        onFileFinish: callbackConfig.onFileFinish,
        onError: callbackConfig.onError,
        onSuccess: (data) => {
          cancelSource = axios.CancelToken.source();
          const url = data.Location.startsWith("https://")
            ? data.Location
            : "https://" + data.Location;
          callbackConfig.onSuccess({
            data,
            cancelSource,
            url: url,
          });
        },
      });
      //  取消上传
      cos.executeCancelTask = () => {
        cos.cancelTask(taskId);
        if (cancelSource) {
          cancelSource.cancel();
        }
      };
      // 暂停上传
      cos.executePauseTask = () => {
        cos.pauseTask(taskId);
      };
      // 恢复上传
      cos.executeRestartTask = () => {
        cos.restartTask(taskId);
      };
    } else {
      throw new Error(signRes.message);
    }
  } catch (error) {
    callbackConfig.onError(error);
  }

  return cos;
};
// 获取上传文件至素材库的签名
const getUploadMaterialSign = (params = {}) => {
  return getUploadSignature({
    fileName: params.name,
    materialType: params.type,
  });
};
// 上传并转码方法
// 参数：file - 文件对象, params - 上传参数, callbackConfig - 回调配置
// 返回值：cos实例，包含控制方法
export const uploadAndTranscodeFile = async (
  file,
  params = {},
  callbackConfig = {}
) => {
  let cos = null;
  let transcodeTaskId = null;
  let transcodeInterval = null;
  let uploadTaskId = null;
  let savedFileId = null; // 跟踪已保存文件的ID
  let isFileSaved = false; // 跟踪文件是否已保存成功
  let isCancelled = false; // 新增：跟踪是否已请求取消
  let isSavingFile = false; // 新增：跟踪是否正在保存文件

  // 设置默认回调函数
  const defaultCallbacks = {
    onTaskReady: () => {},
    // 整体进度
    onProgress: () => {},
    // 文件上传完成还未转码
    onFileFinish: () => {},
    onError: () => {},
    // 转码成功
    onSuccess: () => {},
    onTranscodeStart: () => {},
    onTranscodeComplete: () => {},
    // 新增：详细进度回调
    onUploadProgress: () => {},
    onTranscodeProgress: () => {},
    // 详细进度信息回调
    onDetailedProgress: () => {},
    // 保存成功
    onSaveSuccess: () => {},
  };

  // 合并回调配置
  const mergedCallbacks = { ...defaultCallbacks, ...callbackConfig };

  // 使用 uploadFilToCdn 进行上传
  cos = await uploadFilToCdn(file, params, {
    onTaskReady: (taskId) => {
      console.log("上传任务准备完成", taskId);
      uploadTaskId = taskId;
      mergedCallbacks.onTaskReady(taskId);
    },
    onProgress: (progressData) => {
      // 计算上传进度：50% * 上传百分比
      // COS SDK 的 onProgress 回调接收包含 percent 属性的对象
      const percent = progressData.percent || 0;
      const uploadProgress = percent * 0.5;
      console.log("上传进度", uploadProgress);

      // 调用详细进度回调
      mergedCallbacks.onUploadProgress(percent); // 上传原始进度（0-100）

      // 调用详细进度信息回调
      mergedCallbacks.onDetailedProgress({
        uploadProgress: percent, // 上传原始进度（0-100）
        transcodeProgress: 0, // 转码进度（0-100）
        totalProgress: uploadProgress, // 整体进度（0-50）
        stage: "upload", // 当前阶段
      });

      // 保持向后兼容
      mergedCallbacks.onProgress(uploadProgress);
    },
    onFileFinish: (err, data, options) => {
      console.log("文件上传完成", data);
      mergedCallbacks.onFileFinish(err, data, options);

      if (err) {
        mergedCallbacks.onError(err);
        return;
      }

      // 上传成功后，开始转码流程
      const fileUrl = data.Location.startsWith("https://")
        ? data.Location
        : "https://" + data.Location;

      // 标记开始保存文件
      isSavingFile = true;

      saveFileFn({
        name: file.name,
        materialType: params.type,
        url: fileUrl,
      })
        .then((saveRes) => {
          // 标记保存过程结束
          isSavingFile = false;
          if (saveRes.code === 1) {
            // 记录保存成功状态和文件ID
            isFileSaved = true;
            savedFileId = saveRes.data.id;
            // 调用转码API
            if (params.isNeedTranscode) {
              startTranscode(fileUrl, saveRes.data.id);
            } else {
              mergedCallbacks.onProgress(1);
              mergedCallbacks.onTranscodeComplete({
                materialId: saveRes.data.id,
              });
            }
            mergedCallbacks.onSaveSuccess(saveRes.data);
            // 如果已经请求取消，则执行取消操作
            if (isCancelled) {
              console.log("保存接口成功，但用户已请求取消，执行取消操作");
              executeCancelOperation();
              return;
            }
          } else {
            mergedCallbacks.onError(saveRes.message);
          }
        })
        .catch((error) => {
          // 标记保存过程结束
          isSavingFile = false;

          // 如果已经请求取消，则执行取消操作
          if (isCancelled) {
            console.log("保存接口失败，但用户已请求取消，执行取消操作");
            executeCancelOperation();
            return;
          }

          mergedCallbacks.onError(error);
        });
    },
    onError: (error) => {
      console.error("上传失败", error);
      mergedCallbacks.onError(error);
    },
    onSuccess: (result) => {
      console.log("上传成功", result);
      // onSuccess 只用于通知上传成功，不启动转码
    },
  });

  // 开始转码
  const startTranscode = async (fileUrl, id) => {
    try {
      mergedCallbacks.onTranscodeStart();
      transcodeInterval = setInterval(() => {
        console.log("查询转码进度，任务ID:", id);
        checkTranscodeProgress(id);
      }, 5000); // 每5秒查询一次
      // // 调用创建转码任务API
      // const transcodeParams = {
      //   IsStaticPPT: isPdfFile(file.name), // 可以根据需要调整
      //   ThumbnailResolution: "720x540",
      //   Url: fileUrl + "?for_tiw=1",
      // };

      // const transcodeRes = await createTranscode(transcodeParams);

      // if (transcodeRes.code === 1 && transcodeRes?.data) {
      //   transcodeTaskId = transcodeRes.data;
      //   console.log("转码任务创建成功", transcodeTaskId);

      //   // 开始轮询转码进度
      //   transcodeInterval = setInterval(() => {
      //     console.log("查询转码进度，任务ID:", transcodeTaskId);
      //     checkTranscodeProgress(transcodeTaskId);
      //   }, 5000); // 每5秒查询一次
      // } else {
      //   throw new Error(transcodeRes.message || "转码任务创建失败");
      // }
    } catch (error) {
      console.error("转码启动失败", error);
      mergedCallbacks.onError(error);
    }
  };

  // 检查转码进度
  const checkTranscodeProgress = async (materialId) => {
    try {
      const progressRes = await getDesTranscode({ material_id: materialId });

      if (progressRes.code === 1 && progressRes?.data) {
        const transcodeData = progressRes.data;
        const transcodeProgress = transcodeData.TranscodeProgress;
        const status = transcodeData.TranscodeState; // 0为无需转码，1为正在转码，2为转码失败，3为转码成功

        console.log("转码状态", status, transcodeData);

        // 处理状态值（兼容大小写）
        // const normalizedStatus = status?.toUpperCase();

        if (status === 3) {
          // 转码完成，进度为100%
          console.log("转码完成，清除定时器");
          clearInterval(transcodeInterval);
          transcodeInterval = null; // 确保定时器被清除

          // 调用详细进度回调
          mergedCallbacks.onTranscodeProgress(1); // 转码完成（100%）

          // 调用详细进度信息回调
          mergedCallbacks.onDetailedProgress({
            uploadProgress: 1, // 上传已完成（100%）
            transcodeProgress: 1, // 转码完成（100%）
            totalProgress: 1, // 整体进度（100%）
            stage: "complete", // 当前阶段
          });

          // 保持向后兼容
          mergedCallbacks.onProgress(1);
          mergedCallbacks.onTranscodeComplete({ materialId, ...transcodeData });
          mergedCallbacks.onSuccess({
            uploadData: params,
            transcodeData: transcodeData,
            fileUrl: transcodeData.ResultUrl,
            title: transcodeData.Title,
            pages: transcodeData.Pages,
            resolution: transcodeData.Resolution,
          });
        } else if (status === 1) {
          // 转码进行中，进度为50% + 50% * 转码进度
          const transcodeProgress = transcodeData.TranscodeProgress / 100;
          const totalProgress = 0.5 + 0.5 * transcodeProgress;

          // 调用详细进度回调
          mergedCallbacks.onTranscodeProgress(transcodeProgress); // 转码原始进度（0-1）

          // 调用详细进度信息回调
          mergedCallbacks.onDetailedProgress({
            uploadProgress: 1, // 上传已完成（100%）
            transcodeProgress: transcodeProgress, // 转码进度（0-1）
            totalProgress: totalProgress, // 整体进度（0.5-1
            stage: "transcode", // 当前阶段
          });

          // 保持向后兼容
          mergedCallbacks.onProgress(totalProgress);
        } else if (status === 2) {
          // 转码失败
          console.log("转码失败，清除定时器");
          clearInterval(transcodeInterval);
          transcodeInterval = null;
          throw new Error("转码失败");
        } else {
          // 其他状态，继续查询
          console.log("转码状态未知:", status);
        }
      } else {
        throw new Error(progressRes.message || "查询转码进度失败");
      }
    } catch (error) {
      console.error("查询转码进度失败", error);
      clearInterval(transcodeInterval);
      transcodeInterval = null;
      mergedCallbacks.onError(error);
    }
  };

  // 执行取消操作的内部函数
  const executeCancelOperation = async () => {
    console.log("执行取消操作");

    // 如果文件已经保存成功，需要调用删除接口
    if (isFileSaved && savedFileId) {
      try {
        console.log("文件已保存成功，正在删除已保存的文件", savedFileId);
        await deleteFile({
          material_id: savedFileId,
        });
        console.log("已保存的文件删除成功");
      } catch (error) {
        console.error("删除已保存的文件失败", error);
      }
    }

    if (cos && uploadTaskId) {
      cos.cancelTask(uploadTaskId);
    }
    if (transcodeInterval) {
      clearInterval(transcodeInterval);
      transcodeInterval = null;
    }
  };

  // 添加取消任务的方法
  cos.executeCancelTask = async () => {
    console.log("用户请求取消任务");

    // 标记已请求取消
    isCancelled = true;

    // 如果正在保存文件，等待保存接口完成后再执行取消操作
    if (isSavingFile) {
      console.log("正在保存文件，等待保存接口完成后再执行取消操作");
      return; // 直接返回，等待保存接口完成后的回调中执行取消操作
    }

    // 如果没有在保存文件，立即执行取消操作
    await executeCancelOperation();
  };

  // 添加暂停任务的方法
  cos.executePauseTask = () => {
    if (cos) {
      cos.pauseTask();
    }
  };

  // 添加恢复任务的方法
  cos.executeRestartTask = () => {
    if (cos) {
      cos.restartTask();
    }
  };

  // 添加检查定时器状态的方法
  cos.getTranscodeIntervalStatus = () => {
    return {
      hasInterval: !!transcodeInterval,
      taskId: transcodeTaskId,
      isSavingFile, // 返回是否正在保存文件
      isFileSaved, // 返回文件是否已保存
      isCancelled, // 返回是否已请求取消
    };
  };

  return cos;
};
function isPdfFile(fileName) {
  // 检查输入是否为字符串
  if (typeof fileName !== "string") {
    return false;
  }

  // 去除文件名前后的空格
  const trimmedName = fileName.trim();

  // 检查文件名是否以.pdf或.PDF结尾
  const pdfExtensionRegex = /\.pdf$/i;
  return pdfExtensionRegex.test(trimmedName);
}

const saveFileFn = (params) => {
  const { name, materialType, url } = params;

  return saveFile(
    {
      id: 0,
      material_name: name,
      material_type: materialType,
      pid: 0,
      url: url,
    },
    {}
  );
};
